import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'promocion',
    pure: false
})
export class PromocionPipe implements PipeTransform {

    contadores: number = 0 ;

    transform(array: any) {
        if (this.contadores < array.length ) {
            let img = typeof array[this.contadores] != 'undefined' ? array[this.contadores].imageUrl : '';
            this.contadores++;
            return `<img src='${img}'>`;
        } else {
          this.contadores = 0 ;
          let img = typeof array[this.contadores] != 'undefined' ? array[this.contadores].imageUrl: '';
          return `<img src='${img}'>`;;
        }

    }
}
